var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content pp-introduction"},[_c('h3',{staticClass:"title-p"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"des",domProps:{"innerHTML":_vm._s(_vm.content)}}),_c('img',{attrs:{"src":_vm.img,"alt":"加载失败"}})])}
var staticRenderFns = []

export { render, staticRenderFns }